export default __webpack_public_path__ + "static/media/sound.d80746ad.mp3";